import React from 'react';
import '../Styles/PreFooter.css';
import '../Styles/Footer.css';


const repeatIcon =<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="m7 22-4-4 4-4 1.4 1.45L6.85 17H17v-4h2v6H6.85l1.55 1.55ZM5 11V5h12.15L15.6 3.45 17 2l4 4-4 4-1.4-1.45L17.15 7H7v4Z"/></svg>
const shieldIcon=<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M12 22q-3.475-.875-5.737-3.988Q4 14.9 4 11.1V5l8-3 8 3v6.1q0 3.8-2.262 6.912Q15.475 21.125 12 22Zm0-2.1q2.6-.825 4.3-3.3 1.7-2.475 1.7-5.5V6.375l-6-2.25-6 2.25V11.1q0 3.025 1.7 5.5t4.3 3.3Zm0-7.9Z"/></svg>
const mapIcon=<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="m15 21-6-2.1-4.65 1.8q-.5.2-.925-.113Q3 20.275 3 19.75v-14q0-.325.188-.575.187-.25.512-.375L9 3l6 2.1 4.65-1.8q.5-.2.925.112.425.313.425.838v14q0 .325-.188.575-.187.25-.512.375Zm-1-2.45V6.85l-4-1.4v11.7Zm2 0 3-1V5.7l-3 1.15ZM5 18.3l3-1.15V5.45l-3 1ZM16 6.85v11.7Zm-8-1.4v11.7Z"/></svg>

const youtubeIcon=<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M15.4 17.95q-.675.025-1.287.038Q13.5 18 13.025 18H12q-1.775 0-3.325-.05-1.325-.05-2.613-.138-1.287-.087-1.862-.237-.65-.175-1.125-.65-.475-.475-.65-1.125-.15-.575-.237-1.4-.088-.825-.138-1.575Q2 11.925 2 11q0-.925.05-1.825.05-.75.138-1.575.087-.825.237-1.4.175-.65.65-1.125.475-.475 1.125-.65.575-.15 1.862-.238Q7.35 4.1 8.675 4.05 10.225 4 12 4q1.775 0 3.325.05 1.325.05 2.613.137 1.287.088 1.862.238.65.175 1.125.65.475.475.65 1.125.15.575.237 1.4.088.825.138 1.575.05.9.05 1.825v.425q-.475-.2-.975-.312Q20.525 11 20 11q-2.075 0-3.538 1.462Q15 13.925 15 16q0 .525.1 1.012.1.488.3.938ZM10 14l5.2-3L10 8Zm9 5v-2h-2v-2h2v-2h2v2h2v2h-2v2Z"/></svg>

const twitterIcon=<svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-44.7006 -60.54775 387.4052 363.2865"><path d="M93.719 242.19c112.46 0 173.96-93.168 173.96-173.96 0-2.646-.054-5.28-.173-7.903a124.338 124.338 0 0030.498-31.66c-10.955 4.87-22.744 8.148-35.11 9.626 12.622-7.57 22.313-19.543 26.885-33.817a122.62 122.62 0 01-38.824 14.841C239.798 7.433 223.915 0 206.326 0c-33.764 0-61.144 27.381-61.144 61.132 0 4.798.537 9.465 1.586 13.941-50.815-2.557-95.874-26.886-126.03-63.88a60.977 60.977 0 00-8.279 30.73c0 21.212 10.794 39.938 27.208 50.893a60.685 60.685 0 01-27.69-7.647c-.009.257-.009.507-.009.781 0 29.61 21.075 54.332 49.051 59.934a61.218 61.218 0 01-16.122 2.152 60.84 60.84 0 01-11.491-1.103c7.784 24.293 30.355 41.971 57.115 42.465-20.926 16.402-47.287 26.171-75.937 26.171-4.929 0-9.798-.28-14.584-.846 27.059 17.344 59.189 27.464 93.722 27.464"/></svg>


const facebookIcon=<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24"><path d="M15.12,5.32H17V2.14A26.11,26.11,0,0,0,14.26,2C11.54,2,9.68,3.66,9.68,6.7V9.32H6.61v3.56H9.68V22h3.68V12.88h3.06l.46-3.56H13.36V7.05C13.36,6,13.64,5.32,15.12,5.32Z"/></svg>


const instagramIcon=<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24"><path d="M12,9.52A2.48,2.48,0,1,0,14.48,12,2.48,2.48,0,0,0,12,9.52Zm9.93-2.45a6.53,6.53,0,0,0-.42-2.26,4,4,0,0,0-2.32-2.32,6.53,6.53,0,0,0-2.26-.42C15.64,2,15.26,2,12,2s-3.64,0-4.93.07a6.53,6.53,0,0,0-2.26.42A4,4,0,0,0,2.49,4.81a6.53,6.53,0,0,0-.42,2.26C2,8.36,2,8.74,2,12s0,3.64.07,4.93a6.86,6.86,0,0,0,.42,2.27,3.94,3.94,0,0,0,.91,1.4,3.89,3.89,0,0,0,1.41.91,6.53,6.53,0,0,0,2.26.42C8.36,22,8.74,22,12,22s3.64,0,4.93-.07a6.53,6.53,0,0,0,2.26-.42,3.89,3.89,0,0,0,1.41-.91,3.94,3.94,0,0,0,.91-1.4,6.6,6.6,0,0,0,.42-2.27C22,15.64,22,15.26,22,12S22,8.36,21.93,7.07Zm-2.54,8A5.73,5.73,0,0,1,19,16.87,3.86,3.86,0,0,1,16.87,19a5.73,5.73,0,0,1-1.81.35c-.79,0-1,0-3.06,0s-2.27,0-3.06,0A5.73,5.73,0,0,1,7.13,19a3.51,3.51,0,0,1-1.31-.86A3.51,3.51,0,0,1,5,16.87a5.49,5.49,0,0,1-.34-1.81c0-.79,0-1,0-3.06s0-2.27,0-3.06A5.49,5.49,0,0,1,5,7.13a3.51,3.51,0,0,1,.86-1.31A3.59,3.59,0,0,1,7.13,5a5.73,5.73,0,0,1,1.81-.35h0c.79,0,1,0,3.06,0s2.27,0,3.06,0A5.73,5.73,0,0,1,16.87,5a3.51,3.51,0,0,1,1.31.86A3.51,3.51,0,0,1,19,7.13a5.73,5.73,0,0,1,.35,1.81c0,.79,0,1,0,3.06S19.42,14.27,19.39,15.06Zm-1.6-7.44a2.38,2.38,0,0,0-1.41-1.41A4,4,0,0,0,15,6c-.78,0-1,0-3,0s-2.22,0-3,0a4,4,0,0,0-1.38.26A2.38,2.38,0,0,0,6.21,7.62,4.27,4.27,0,0,0,6,9c0,.78,0,1,0,3s0,2.22,0,3a4.27,4.27,0,0,0,.26,1.38,2.38,2.38,0,0,0,1.41,1.41A4.27,4.27,0,0,0,9,18.05H9c.78,0,1,0,3,0s2.22,0,3,0a4,4,0,0,0,1.38-.26,2.38,2.38,0,0,0,1.41-1.41A4,4,0,0,0,18.05,15c0-.78,0-1,0-3s0-2.22,0-3A3.78,3.78,0,0,0,17.79,7.62ZM12,15.82A3.81,3.81,0,0,1,8.19,12h0A3.82,3.82,0,1,1,12,15.82Zm4-6.89a.9.9,0,0,1,0-1.79h0a.9.9,0,0,1,0,1.79Z"/></svg>


const Footer = ({footer}) => {
  return (
    <>
    <div className='prefooter'>
        
        <div>
                {repeatIcon}
                 <p> <b>Hassle-free replacement</b> <br/>10-day easy replacement policy on mi.com</p>
               </div>
               <div>{shieldIcon} <p> <b>100% secure payments</b> <br/> We support Cards, Wallets, EMI and COD</p></div>
            <div>{mapIcon} <p> <b>Vast service network</b> <br/> 1000 Mi service-centers across 600 cities</p></div>
        </div>
        <div className="prefooter2">
             <div> <p>LET'S STAY IN TOUCH</p><span>Get updates on sales specials and more</span></div>

             <div>
                 <div>
                     <input type="email" name="email" placeholder="Enter Email Address" />
                     <button>›</button>
                 </div>
                 <span>Thanks. You're on our email list for special offers.</span>
             </div>

             <div>
                    <p>FOLLOW MI</p>
                    <span>We want to hear from you!</span>
             </div>

             <div>
                {facebookIcon} {youtubeIcon} {instagramIcon} {twitterIcon} 
             </div>
        </div>

        <div className='footer'>

        <div>
            <p>SUPPORT</p>
            {footer.support.map((item,index)=>(
               <a href={item.url} key={item.url}>{item.name}</a> 
            ))}
        </div>

        <div>
            <p>SHOP AND LEARN</p>
            {footer.shopAndLearn.map((item,index)=>(
                <a href={item.url} key={item.url}>{item.name}</a>
            ))}
        </div>
        
        <div>
            <p>RETAIL STORE</p>
            {footer.retailStore.map((item,index)=>(
                <a href={item.url} key={item.url}>{item.name}</a>
            ))}
        </div>
        
        <div>
            <p>ABOUT US</p>
            {footer.aboutUS.map((item,index)=>(
                <a href={item.url} key={item.url}>{item.name}</a>
            ))}
        </div>

        <div>
            <p>CONTACT US</p>
            {footer.contactUs.map((item,index)=>(
                <a href={item.url} key={item.url}>{item.name}</a>
            ))}
        </div>

        <div>
            <div>Chat with our Virtual AI Bot(24/7 Live Agent Support)</div><button>Chat Now</button>
        </div>





        </div>

        <div className='borderfooter'>
            <div> Copyright &#169; 2010 - 2023 Xiaomi. All Rights Reserved</div>
        </div>
    
    
    
    
    
    </>
  )
}

export default Footer